/**
 * Is the product passed in in the favorited product set?
 * @param state Redux state
 * @param product product state, should have style number
 */
export function isProductFavorited(state, product) {
    const styles = new Set(Object.keys(_.get(state, 'core.favoritedStyles', {})));
    return styles.has(product.styleNumber);
}

/**
 * Apply favorites to a list of products
 * @param state Redux state
 * @param products List of product objects
 */
export function applyFavorites(state, products) {
    const styles = new Set(Object.keys(_.get(state, 'core.favoritedStyles', {})));

    if (!products) {
        return [];
    }

    products.forEach((product) => {
        product.product.favorited = styles.has(product.product.styleNumber);
    });

    return products;
}
